<template>
    <div class="new-chip" :class="{'ac-bg-gray': ac}">
        <header-component :is-soon="false" :backRoute="getBackRoute()" img-left="/trocachip/img/setinha-left-preto.svg" img-right="/trocachip/img/access.png" class="header-component" />
        <div :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"></div>
        <div class="container">
            <h2 id="title" class="new-chip_title" :class="{'ac-color-white': ac}">
                Só faltam algumas informações do seu novo chip
            </h2>
            <span class="new-chip_info" :class="{'ac-color-white': ac}">
                 <a @click="information = !information">Clique aqui</a> e visualize as informações na embalagem.
            </span>
            <section class="new-chip_code">
                <!-- <label :class="{'ac-color-white': ac}">CÓDIGO DE BARRAS</label> -->
                <a class="new-chip_code_reader" @click="barCode = true">
                    <img src="../assets/images/bar-code.svg" v-if="!ac">
                    <img src="../assets/images/bar-code-ac.svg" v-if="ac">
                    <span :class="{'ac-color-yellow': ac}">Utilize o leitor de código de barras</span>
                </a>

                <section>
                    <input id="barcodefield" type="text" @blur="checkCodeValue()" @keydown="cleanCodeErrors()" v-mask="'####################'" :placeholder="barCodeInputPlaceholder" v-model="codeValue" :class="{'ac-color-white': ac, 'ac-input': ac}">
                    <img v-if="isValid" src="../assets/images/green-check.svg">
                    <span id="errorincompletebarcode" v-show="errors.incomplete" class="error-danger">O campo CÓDIGO DE BARRAS está incompleto</span>
                </section>
            </section>
            <section>
                <code-bar-reader v-if="barCode" v-on:codeResult="codeReader" v-on:close="closeBarReader"/>
            </section>
            <div class="next_submit">
                <button id="continuebarcode" class="btn_next" :class="{ 'btn_next_active' : isValid, 'bt_no_click': loader, 'ac-border-yellow': ac, 'ac-bg-gray': ac, 'ac-color-yellow': ac, 'btn_next_active_loader' : loader }" :disabled="!isValid" @click="next()"  >
                    <loader-bottom v-if="loader"/>
                    <span v-if="!loader">Continuar</span>
                </button>
            </div>
        </div>
        <alert
                description="Erro ao enviar a solicitação"
                danger="true"
                message="Por favor, tente novamente mais tarde"
                v-on:close="alertError = !alertError"
                v-if="alertError"
        />
        <information-component
                message="As informações solicitadas estão marcadas em vermelho."
                v-on:close="information = !information"
                v-if="information"
        />
    </div>
</template>

<script>
    import HeaderComponent from "../components/HeaderComponent";
    import LoaderBottom from "../components/LoaderBottom";
    import Order from "../services/order";
    import Alert from "../components/Alert";
    import InformationComponent from "../components/InformationComponent";
    import CodeBarReader from "../components/CodeBarReader"
    import {mapState} from "vuex";
    import trackEvent from "../services/trackEvent";

    export default {
        name: "NewChip",
        components: {
            HeaderComponent,
            Alert,
            InformationComponent,
            LoaderBottom,
            CodeBarReader
            
        },
        data() {
            return {
                codeValue: '',
                errors: {
                    incomplete: false,
                },
                isValid: false,
                barCode: false,
                alertError: false,
                alertErrorMessage: '',
                information: false,
                loader: false,
                barCodeInputPlaceholder: ''
            }
        },
        created() {
            if(this.document === '' && this.pinToken === '') return this.$router.push('/codigo')
            this.barCodeInputPlaceholder = this.config.new_chip_barcode_placeholder;
        },
        computed: mapState({
            ac: state => state.ac,
            document: state => state.document,
            pinToken: state => state.pinToken,
            pin: state => state.pin,
            code: state => state.code,
            config: state => state.config,
            customer: state => state.customer,
            reason: state => state.reason
        }),
        watch: {
            codeValue: function () {
                if (this.codeValue.length === 20) {
                    this.errors.incomplete = this.codeValue.length > 0 && this.codeValue.length < 20;
                    this.isValid = this.codeValue.length === 20;
                }
            },
            barCode: function(oldValue, newValue) {
                if(!newValue)
                    trackEvent.track({
                        'user': {
                            'login': this.customer.login,
                            'loginType':  '',
                            'lineType':  this.customer.loginType,
                            'segment': this.customer.segment,
                            'subSegment':  this.customer.subSegment,
                            'planCode': this.customer.planCode,
                            'planName':  this.customer.planName
                        },
                        'channel': trackEvent.getChannel(),
                        'event-category': 6,
                        'event-label': 'Troca de Chip Leitor Codigo de Barras',
                        'event-value': null,
                        'event-status': 'Sucesso',
                        'event-interactionNumber': ''
                    })
            }
        },
        methods: {
            getBackRoute() {
                if(this.config.enable_email_validation_chip)
                    return '/email-validation'
                return '/codigo'
            },
            getLastRoute() {
                this.$store.dispatch('popRoute');
                const routeStack = this.$store.getters.getRouteStack();
                const lastRoute = routeStack.pop();

                return lastRoute;
            },
            cleanCodeErrors() {
                this.errors = {
                    incomplete: false,
                }
            },
            checkCodeValue() {
                this.errors.incomplete = this.codeValue.length > 0 && this.codeValue.length < 20;
                this.isValid = this.codeValue.length === 20;
            },
            notAuthorizedClient(title, desc) {
                this.$router.push({ name: "default-error", params: {
                    title: title,
                    description: desc,
                    actionLabel: "Acesse o portal",
                    action: function () {
                        trackEvent.track({
                            'user': {
                                'login': this.customer.login,
                                'loginType':  '',
                                'lineType':  this.customer.loginType,
                                'segment': this.customer.segment,
                                'subSegment':  this.customer.subSegment,
                                'planCode': this.customer.planCode,
                                'planName':  this.customer.planName
                            },
                            'channel': trackEvent.getChannel(),
                            'event-category': 6,
                            'event-label': 'Troca de Chip Erro Acesse o Portal',
                            'event-value': null,
                            'event-status': 'Sucesso',
                            'event-interactionNumber': ''
                        })
                        window.location.replace(this.config.not_authorized_redirect_url);
                    }
                }})
            },
            next() {
                this.loader = true;
                this.$store.dispatch('barCode', this.codeValue.replace(/ /g,""));

                Order.getOrder(this.code, this.pinToken, this.codeValue.replace(/ /g,""), this.reason).then( response => {
                    if(response.data.internalCode == "1") {
                        this.$store.dispatch('protocol', response.data.protocol)
                        this.$router.push('/ativado')
                        trackEvent.track({
                            'user': {
                                'login': this.customer.login,
                                'loginType':  '',
                                'lineType':  this.customer.loginType,
                                'segment': this.customer.segment,
                                'subSegment':  this.customer.subSegment,
                                'planCode': this.customer.planCode,
                                'planName':  this.customer.planName
                            },
                            'channel': trackEvent.getChannel(),
                            'event-category': 6,
                            'event-label': 'Troca de Chip Validar Chip',
                            'event-value': null,
                            'event-status': 'Sucesso',
                            'event-interactionNumber': '',
                            'event-action': 2
                        })
                    } else {
                        if (response.data.internalCode == "-40001") {
                            this.notAuthorizedClient(response.data.title, response.data.desc);
                            return;
                        }
                        this.loader = false;
                        this.alertError = true
                        this.alertErrorMessage = response.data.desc
                        trackEvent.track({
                            'user': {
                                'login': this.customer.login,
                                'loginType':  '',
                                'lineType':  this.customer.loginType,
                                'segment': this.customer.segment,
                                'subSegment':  this.customer.subSegment,
                                'planCode': this.customer.planCode,
                                'planName':  this.customer.planName
                            },
                            'channel': trackEvent.getChannel(),
                            'event-category': 6,
                            'event-label': 'Troca de Chip Validar Chip',
                            'event-value': null,
                            'event-status': 'Erro',
                            'event-interactionNumber': '',
                            'event-error': response.data.message,
                            'event-action': 2
                        })
                    }
                }).catch( error => {
                    if (error.response.data.internalCode == "-40001") {
                        this.notAuthorizedClient(error.response.data.message, error.response.data.desc);
                        return;
                    }
                    this.loader = false;
                    this.alertError = true
                    this.alertErrorMessage = error.response.data.desc
                    trackEvent.track({
                        'user': {
                            'login': this.customer.login,
                            'loginType':  '',
                            'lineType':  this.customer.loginType,
                            'segment': this.customer.segment,
                            'subSegment':  this.customer.subSegment,
                            'planCode': this.customer.planCode,
                            'planName':  this.customer.planName
                        },
                        'channel': trackEvent.getChannel(),
                        'event-category': 6,
                        'event-label': 'Troca de Chip Validar Chip',
                        'event-value': null,
                        'event-status': 'Erro',
                        'event-interactionNumber': '',
                        'event-error': error.response.data.message,
                        'event-action': 2
                    })
                })
            },
            codeReader(code) {
                this.codeValue = code;
                return this.barCode = false;
            },
            closeBarReader() {
                this.barCode = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .new-chip {
        width: 100%;
        height: 100%;
        display: block;
        position: fixed;
        z-index: -1;
        overflow-y: auto;
        .bt_no_click {
            z-index: -1;
        }
        > div {
            > .new-chip_title {
                width: 265px;
                height: auto;
                display: block;
                position: relative;
                margin: 96px auto 0 auto;
                font-family: 'timsans_regular';
                font-size: 1.688em;
                font-weight: 300;
                line-height: 1.11;
                text-align: center;
                color: #181818;
            }
            > .new-chip_info {
                width: 252px;
                height: auto;
                margin: 16px auto 0 auto;
                display: block;
                position: relative;
                font-family: 'timsans_regular';
                font-size: 0.875em;
                line-height: 1.29;
                text-align: center;
                color: #808080;
                > a {
                    text-decoration: underline;
                    color: #808080;
                }
            }
            > .new-chip_code {
                width: 265px;
                height: auto;
                display: block;
                position: relative;
                margin: 40px auto 0 auto;
                > label {
                    width: 100%;
                    height: auto;
                    display: block;
                    position: relative;
                    font-family: 'timsans_regular';
                    font-size: 0.75em;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #6c6c6c;
                }
                > section {
                    position: relative;
                }
                > section input {
                    font-size: 12px;
                    color: #B3B3B3;
                }
                > section img {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-100%);
                    right: 0;
                }
                > .new-chip_code_reader {
                    min-height: 34px;
                    margin: 0px auto 16px auto;
                    display: grid;
                    align-items: center;
                    grid-template-columns: 24px auto;
                    position: relative;
                    > img {
                        width: 24px;
                        height: 24px;
                        display: block;
                        position: relative;
                        fill: #001ccf;
                    }
                    > span {
                        font-family: 'timsans_regular';
                        font-size: 0.875em;
                        color: #001ccf;
                        padding-left: 8px;
                    }
                }
            }
        }
    }
    .btn_next_active_loader {
        width: 52px !important;
        transition: width 2s;
    }

    @media (min-width: 768px) {
        .new-chip {
            width: 100%;
            height: 100%;
            display: grid;
            grid-auto-columns: 50% 50%;
            grid-template-areas:
                    'header header'
                    'container background';
            position: absolute;
            z-index: -1;
            overflow-y: auto;
            .bt_no_click {
                z-index: -1;
            }

            .header-component {
                width: 45%;
                grid-area: header;
            }

            .background-desktop {
                grid-area: background;
                width: 100%;
                height: 100vh;
                display: block;
                background: url("../assets/images/desktop@3x.png") no-repeat;
                background-size: cover;
            }

            .background-desktop-black {
                grid-area: background;
                width: 100%;
                height: 100vh;
                display: block;
                background: url("../assets/images/desktop-black.png") no-repeat;
                background-size: cover;
            }

            > .container {
                grid-area: container;
                > .new-chip_title {
                    width: 434px;
                    height: auto;
                    display: block;
                    margin: 115px auto 0 auto;
                    font-family: 'timsans_thin';
                    font-size: 2em;
                    font-weight: 300;
                    line-height: 1.2;
                }
                > .new-chip_info {
                    width: 400px;
                    height: auto;
                    margin: 24px auto 0 auto;
                    display: block;
                    position: relative;
                    font-family: 'timsans_regular';
                    font-size: 0.875em;
                    line-height: 1.29;
                    text-align: center;
                    color: #808080;
                    > a {
                        text-decoration: underline;
                        color: #808080;
                    }
                }
                > .new-chip_code {
                    width: 400px;
                    height: auto;
                    display: block;
                    position: relative;
                    margin: 80px auto 0 auto;
                    > label {
                        width: 100%;
                        height: auto;
                        display: block;
                        position: relative;
                        font-family: 'timsans_regular';
                        font-size: 0.75em;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        color: #6c6c6c;
                    }
                    > .new-chip_code_reader {
                        display: none;
                    }
                }
            }
        }
    }
</style>